<template>
  <a>
    <span class="modal-body-text">Normal event scheduling requires 90 days notice, please choose a date that meets these requirements or contact ADURO for assistance scheduling an event sooner.</span><br/>
  </a>
</template>

<script>
export default {
  name: 'change-submitted-body-modal'
}
</script>

<style lang="less">

</style>




// WEBPACK FOOTER //
// EventTimeInvalid.vue?48c4c11e